import { useMessageContext } from "../Providers";

export default function useMessage() {
    const { messageDispatch } = useMessageContext();
    const triggerEvent = (key) => {
        const event = new Event("storage");
        event.key = key;
        window.dispatchEvent(event);
    };
    const Positions = {
        POSITION_TOP_LEFT: "tl",
        POSITION_TOP_CENTER: "tc",
        POSITION_TOP_RIGHT: "tr",
        POSITION_TOP_BOTTOM_LEFT: "bl",
        POSITION_TOP_BOTTOM_CENER: "bc",
        POSITION_TOP_BOTTOM_RIGHT: "br",
    };

    const Types = {
        TYPE_MESSAGE: "success",
        TYPE_ERROR: "danger",
        TYPE_WARNING: "warning",
        TYPE_INFO: "info",
        TYPE_NOCONNECTION: "secondary",
    };

    const Icons = {
        DEFAULT_WARNING_ICON: "fa-solid fa-triangle-exclamation",
        DEFAULT_MESSAGE_ICON: "fa-solid fa-square-check",
        DEFAULT_ERROR_ICON: "fa-solid fa-circle-exclamation",
        DEFAULT_NOCONNECTION_ICON: "fa-solid fa-wifi",
    };

    const Message = (data) => {
        messageDispatch({
            type: "ADD",
            payload: {
                content: {
                    type: data.type ? data.type : Types.TYPE_MESSAGE,
                    message: data.message,
                    messages: data.messages,
                    place: data.place ? data.place : Positions.POSITION_TOP_BOTTOM_RIGHT,
                    icon: data.icon ? data.icon : Icons.DEFAULT_MESSAGE_ICON,
                    autoDismiss: data.autoDismiss ? data.autoDismiss : 10,
                    closeButton: data.closeButton ? data.closeButton : true,
                },
            },
        });
    };
    const Warning = (data) => {
        messageDispatch({
            type: "ADD",
            payload: {
                content: {
                    type: Types.TYPE_WARNING,
                    message: data.message,
                    messages: data.messages,
                    place: data.place ? data.place : Positions.POSITION_TOP_BOTTOM_RIGHT,
                    icon: data.icon ? data.icon : Icons.DEFAULT_WARNING_ICON,
                    autoDismiss: data.autoDismiss ? data.autoDismiss : 0,
                    closeButton: data.closeButton ? data.closeButton : true,
                },
            },
        });
    };

    const Error = (data) => {
        messageDispatch({
            type: "ADD",
            payload: {
                content: {
                    type: Types.TYPE_ERROR,
                    message: data.message,
                    messages: data.messages,
                    place: data.place ? data.place : Positions.POSITION_TOP_BOTTOM_RIGHT,
                    icon: data.icon ? data.icon : Icons.DEFAULT_ERROR_ICON,
                    autoDismiss: data.autoDismiss ? data.autoDismiss : 0,
                    closeButton: data.closeButton ? data.closeButton : true,
                },
            },
        });
    };

    const NoConnection = (data) => {
        messageDispatch({
            type: "ADD",
            payload: {
                content: {
                    type: Types.TYPE_NOCONNECTION,
                    message: data.message,
                    messages: data.messages,
                    place: data.place ? data.place : Positions.POSITION_TOP_CENTER,
                    icon: data.icon ? data.icon : Icons.DEFAULT_NOCONNECTION_ICON,
                    autoDismiss: data.autoDismiss ? data.autoDismiss : 0,
                    closeButton: data.closeButton ? data.closeButton : false,
                },
            },
        });
    };

    const cerrarAlertas = () => {
        messageDispatch({
            type: "CLOSE",
        });
        triggerEvent("cerrarAlertas");
    };

    return {
        Message,
        Warning,
        Error,
        NoConnection,
        cerrarAlertas,
        Positions,
        Types,
    };
}
